// ============================================================================
// Z-INDEX 常數系統
// ============================================================================
// 層級規劃：
// - 底層 (negative ~ 10)：局部堆疊、背景層
// - 基礎層 (10 ~ 100)：頁面元素、sticky、篩選列
// - 中間層 (100 ~ 1000)：sidebar、menu、固定元素
// - Modal 層 (1000 ~ 10000)：各種 modal、dropdown
// - 全螢幕層 (10000 ~ 100000)：全螢幕 modal、相簿、照片檢視器
// - 最高層 (100000+)：SweetAlert、確認框、服務成本編輯
// ============================================================================

// ----------------------------------------------------------------------------
// 底層 (Negative ~ 0)：背景、偽元素、裝飾層
// ----------------------------------------------------------------------------
export const Z_BACKGROUND_BEHIND = -1;       // 偽元素背景、裝飾層
export const Z_BACKGROUND_BASE = 0;          // 基礎底層

// ----------------------------------------------------------------------------
// 局部堆疊層 (1 ~ 9)：卡片內容、表單元素、局部前景
// ----------------------------------------------------------------------------
export const Z_LOCAL_CONTENT = 1;            // 卡片內容、stepper 圓圈
export const Z_LOCAL_FOREGROUND = 2;         // 高於 content 的前景元素
export const Z_LOCAL_HIGHLIGHT = 3;          // 局部高亮、badge
export const Z_LOCAL_FILTER = 5;             // 篩選列、表頭列
export const Z_LOCAL_ACTION = 6;             // 操作列、發票設定
export const Z_LOCAL_CARD_BG = 8;            // 服務方案卡片背景
export const Z_LOCAL_TOOLBAR = 9;            // EditorJS 工具列

// ----------------------------------------------------------------------------
// 基礎層 (10 ~ 99)：頁面元素、sticky、固定按鈕
// ----------------------------------------------------------------------------
export const Z_BASE_ELEMENT = 10;            // 固定按鈕、modal 內 toolbar、sticky 表頭
export const Z_BASE_CONTROL = 11;            // modal 控制鈕
export const Z_BASE_TAB = 12;                // 庫存明細 tab
export const Z_BASE_BADGE = 15;              // 標籤管理 badge
export const Z_BASE_DROPDOWN = 20;           // 通用 dropdown、標籤管理 Select
export const Z_BASE_STICKY = 25;             // sticky 表頭、帳務稽核 sticky
export const Z_STICKY_TITLE_BG = 28;         // 會員/工單/班表 sticky 標題背景
export const Z_STICKY_TITLE_HEADER = 29;     // sticky 表頭列
export const Z_STICKY_TITLE = 30;            // 頁面標題列
export const Z_PIMS_TITLE = 32;              // Pims 頁面標題列
export const Z_PRELOADER_LOW = 35;           // 全局 preloader 遮罩（低於 sidebar）
export const Z_NEW_HEADER = 40;              // .new-header 主導覽列
export const Z_STACK_OVER_HEADER = 45;       // 高於 header 的堆疊（帳務首頁）
export const Z_PIMS_NAV_SUB = 46;            // Pims 次導覽
export const Z_RESERVATIONS_HELPER = 50;     // 預約 helper 浮層
export const Z_STATISTICS_STICKY = 51;       // 統計頁 sticky 元素
export const Z_PAGE_BG_LOW = 80;             // 預約/訂單/會員明細 背景層
export const Z_PAGE_FG_LOW = 90;             // 預約/訂單/會員明細 前景層、Ant 側欄分頁區
export const Z_MENU_BAR = 98;                // 子頁側欄 menu-bar、filter bar
export const Z_FOOTER = 99;                  // 頁尾、特效層、篩選列

// ----------------------------------------------------------------------------
// 中間層 (100 ~ 999)：sidebar、固定元素、局部 modal
// ----------------------------------------------------------------------------
export const Z_SIDEBAR_CONTENT = 100;        // 側欄子面板、列表 sticky、modal 內局部層
export const Z_SIDEBAR_FOREGROUND = 101;     // 結帳側欄前景
export const Z_SIDEBAR_CONTAINER = 102;      // 側欄相片容器
export const Z_CLOSE_HEADER = 140;           // 關帳頁固定 header
export const Z_BUTTON_HOVER = 199;           // 按鈕 hover/active 層
export const Z_SIDEBAR_MAIN = 998;           // **主 sidebar**（銷售/會員等；須高於 PIMS 頁面層 32–999，低於 modal 1000+）
export const Z_SIDEBAR_APPOINTMENT = 998;    // 預約/工單/掃描側欄
export const Z_HEADER_OLD = 999;             // 舊 header、掃描頁、會員等級 modal
export const Z_FIXED_BUTTON = 990;           // 預約頁固定「+」按鈕
export const Z_APPOINTMENT_NAV = 997;        // 預約導覽列元素

// ----------------------------------------------------------------------------
// Modal 層 (1000 ~ 9999)：Bootstrap modal、Ant dropdown
// ----------------------------------------------------------------------------
export const Z_MODAL_BASE = 1000;            // Bootstrap modal 標準層
export const Z_MODAL_SECONDARY = 1001;       // 次級 modal
export const Z_SIDEBAR_MENU = 1010;          // 主 sidebar menu
export const Z_SIDEBAR_CONSULTATION = 1020;  // 諮詢/掛號側欄
export const Z_MODAL_BACKDROP = 1040;        // Bootstrap modal backdrop
export const Z_MODAL_CONFIRMATION = 1041;    // 預約確認 modal
export const Z_MODAL_DROPDOWN = 1100;        // modal 內 dropdown
export const Z_MODAL_FULLSCREEN_LOW = 2000;  // 全螢幕/側欄 modal、PS 捲軸
export const Z_MODAL_FULLSCREEN_HOVER = 2001;// PS 捲軸 hover/active 更高層
export const Z_MODAL_PORTAL = 2050;          // 編輯分潤 Portal modal
export const Z_PAGINATION_OVERLAY = 2100;    // 分頁 overlay（PAGINATION_OVERLAY_Z_INDEX）
export const Z_MODAL_FULLSCREEN = 2500;      // 預約/會員全螢幕 modal
export const Z_CHECKOUT_MODAL = 3000;        // SidebarCheckout 系列 modal
export const Z_CHECKOUT_DROPDOWN = 3100;     // 會員頁 Ant dropdown
export const Z_RESERVATIONS_FULLSCREEN = 8000;// 預約 helper 全螢幕
export const Z_REPORT_MODAL = 9000;          // 報表/員工 modal
export const Z_EMPLOYEE_MODAL_1 = 9001;      // 員工 modal 堆疊子層 1
export const Z_EMPLOYEE_MODAL_2 = 9002;      // 員工 modal 堆疊子層 2
export const Z_EMPLOYEE_MODAL_3 = 9003;      // 員工 modal 堆疊子層 3
export const Z_SALES_POPMODAL = 9500;        // 銷售全螢幕 popmodal
export const Z_BALANCE_PAYMENT = 9900;       // 尾款付款頁
export const Z_SALES_FIXED_CHROME = 9910;    // 銷售全屏子頁固定右上角分店
export const Z_SALES_CHECKOUT_MODAL = 10050; // 銷售課程結帳彈窗（高於分店選擇 9910）
export const Z_SALES_CHECKOUT_DROPDOWN = 10150; // 銷售課程結帳彈窗內 Select 下拉（須高於 modal 10050；蓋過全站 .ant-select-dropdown 9999 !important）
export const Z_EMPLOYEE_MODAL_SUB = 9990;    // 新增員工某子層
export const Z_GLOBAL_OVERLAY = 9999;        // Ant Design dropdown / 全局浮層

// ----------------------------------------------------------------------------
// 全螢幕層 (10000 ~ 99999)：全螢幕 modal、相簿、照片檢視器
// ----------------------------------------------------------------------------
export const Z_SIDEBAR_CHECKOUT_ROOT = 10000;// 側欄 checkout 根 modal
export const Z_ALBUM_CONTROL_BASE = 10001;   // 相簿控制
export const Z_ANT_TIMEPICKER = 10002;       // Ant time picker
export const Z_CHECKOUT_DETAIL_SIDEBAR = 10007;// 結帳明細側欄
export const Z_EMPLOYEE_CANCEL = 10010;      // 員工 modal 取消
export const Z_EMPLOYEE_CONFIRM = 10011;     // 員工 modal 確認
export const Z_ALBUM_CONTROL_1 = 10020;      // 相簿多層控制 1
export const Z_ALBUM_CONTROL_3 = 10021;      // 相簿多層控制 (sidebar-user-picture)
export const Z_ALBUM_CONTROL_2 = 10025;      // 相簿多層控制 2
export const Z_ALBUM_TAG_EDIT = 10040;       // 相簿標籤編輯
export const Z_POPOVER = 10050;              // Popover/Tooltip
export const Z_ALBUM_FULLSCREEN_CONTROL_1 = 10051;// 相簿全螢幕控制 1
export const Z_ALBUM_FULLSCREEN_CONTROL_2 = 10052;// 相簿全螢幕控制 2
export const Z_PHOTO_VIEWER = 10060;         // 照片 viewer（ComparisonAlert_bg 等）
export const Z_POP_CHECKOUT_PHOTO_VIEWER = 100060; // PopCheckoutDetails 照片 modal（掛 body 蓋全頁）
export const Z_MEMBER_SEARCH_SIDEBAR = 100061; // 銷售／預約搜尋會員側欄（須高於結帳頁分店選擇 99999）
export const Z_UNDERPAID_MODAL = 10100;      // 尾款/更新標籤 modal
export const Z_CUSTOMER_POPMODAL_PORTAL = 10101;// 會員側欄 portal 彈窗外殼（訂單明細／預約資訊等）
/** 會員側欄 portal 內再開的巢狀彈窗（如預約資訊→調度設備；須高於 portal 10101） */
export const Z_CUSTOMER_POPMODAL_NESTED = 10102;
export const Z_CHECKOUT_DETAIL_OVERLAY = 10105;// 結帳紀錄帳單明細等（須高於 customer portal 10101）
export const Z_CHECKOUT_DETAIL_DROPDOWN = 10106;// 結帳明細 modal 內 dropdown（須高於 overlay）
export const Z_CHECKOUT_DETAIL_PRINT_OVERLAY = 10107;// 帳單明細內列印收據／帳單明細（須高於帳單明細 10105、分店選擇 9910）
export const Z_CHECKOUT_WAREHOUSE_DROPDOWN = 10200; // 選擇耗材倉庫 Select（須高於帳單明細＋核銷＋倉庫層；蓋過全站 9999 !important）
/** 問診單／療程紀錄單／術前同意書／療程後確認單／付款同意書／報到問卷（須高於會員側欄 portal 10101、結帳明細 10105） */
export const Z_CLINICAL_DOCUMENT_MODAL = 10110;
export const Z_PAYMENT_CONSENT_MODAL = Z_CLINICAL_DOCUMENT_MODAL;// 付款同意書 editor/picker
export const Z_QUESTIONNAIRE_MODAL = Z_CLINICAL_DOCUMENT_MODAL;// 報到問卷／問卷 QR／作答結果
export const Z_EMPLOYEE_VERIFY_MODAL = 11000;// 驗證 modal / 列印預覽
export const Z_ALBUM_BG = 12000;             // 相簿背景
export const Z_RANGE_PICKER_DROPDOWN = 12150;// 相簿日曆 RangePicker
export const Z_AUDIT_FULLSCREEN = 20000;     // 帳務稽核全螢幕
export const Z_HEADER_SUB = 20010;           // header 子元素

// ----------------------------------------------------------------------------
// 最高層 (100000+)：SweetAlert、確認框、服務成本編輯
// ----------------------------------------------------------------------------
export const Z_UTILITY_MAX = 99999;          // 通用最高 utility / SweetAlert
export const Z_HELPER_FULLSCREEN = 100000;   // helper 全螢幕
export const Z_MEMBER_COURSE_MODAL = 100002; // 會員課程 modal
export const Z_CONFIRMATION_PDF = 100010;    // 預約確認 PDF fallback
export const Z_ORDER_PHOTO_ROOT = 150000;    // 訂單照片總覽根層
export const Z_ORDER_PHOTO_VIEWER = 150001;  // 全螢幕照片檢視器
export const Z_UPLOAD_ALBUM_BG = 220000;     // 上傳全螢幕背景
export const Z_UPLOAD_ALBUM_FG = 220001;     // 上傳相簿 inline
export const Z_UPLOAD_ALBUM_SWAL = 220010;   // 上傳相簿 SWAL
export const Z_SWAL = 230000;                // **SweetAlert2** 全局最高
export const Z_PERMISSION_MANAGEMENT = 231000;// 權限管理（高於 swal2）
export const Z_PRELOADER_HIGH = 999999;      // 尾款/掃描購 preloader
export const Z_SERVICE_COST_EDIT = 99999999; // 服務成本編輯（全專案最高 SCSS）
export const Z_SERVICE_COST_JS = 100000000;  // 分類分享設定（JS inline 最高）
